export const REGION_LIST = [
  { name: '华北1（北京）', value: 'beijing', code: 'cn-beijing-6' },
  { name: '华东1（上海）', value: 'shanghai', code: 'cn-shanghai-2' }
];
